import React, { useEffect, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import {
  desabilitarAcoes,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  revelarExcluirCliente
} from '../../../redux/actions/index'
import PaginacaoTabela from '../../../utils/paginacaoTabela'
import BarraDadosCliente from '../../componentesModais/barraDadosCliente/barraDadosCliente'
import BarraFiltragem from '../../componentesModais/barraFiltragem/barraFiltragem'
import MensagemConfirmarExclusao from '../../componentesModais/mensagens/mensagemConfirmarExclusao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'

import CadastroPapel from './cadastro'
import '../../../css/painelAdministrativo/pavCliente/pavCliente.css'
import '../../../css/painelPermissaoRBAC/cadPapeis/pavPemissao.css'
import '../../../css/painelPermissaoRBAC/perfil/tabela.css'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let totalContador = 0
const valorLimite = 50

function Grid() {
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [nomePapel, setNomePapel] = useState('')
  const [codigoPapel, setCodigoPapel] = useState('')
  const [idPapel, setIdPapel] = useState('')
  const [descricaoPapel, setDescricaoPapel] = useState('')
  const [dsNomeCliente, setDsNomeCliente] = useState('')
  const [selectedRow, setSelectedRow] = useState({})
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [revelarCadastro, setRevelarCadastro] = useState(false)
  const [revelarEdicao, setRevelarEdicao] = useState(false)
  const despacho = useDispatch()
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let separadorLinhas = useSelector(
    (state) => state.manejadorState.separadorLinha
  )
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let filtros = useSelector((state) => state.filtrosState.filtros)
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )
  let NovoCliente = useSelector(
    (state) => state.manejadorState.revelarNovoCliente
  )
  let EditarCliente = useSelector(
    (state) => state.manejadorState.revelarEditarCliente
  )
  let ExcluirCliente = useSelector(
    (state) => state.manejadorState.revelarExcluirCliente
  )

  const [spinAtivo, setSpinAtivo] = useState(true)

  let itensVar = []
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(113) // 'pavClienteTabelaGrid'
      setColetaUsabilidade(false)
    }
  }, [])

  useEffect(() => {
    despacho(revelarBarraFiltragem(false))
    if (!filtros.vazio) {
      despacho(mudarFiltros({ vazio: 'vazio' }))
    }
    despacho(limpadorFiltros(true))
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    despacho(mudarManejador('cadastroPermissionamento'))

    async function getEditedRow(selectedRow, rowArray) {
      let newSelectedRow = rowArray.find(
        (row) => row.CdPapel === selectedRow.selectedRow.CdPapel
      )

      setPropData(newSelectedRow)
      return newSelectedRow
    }
    async function carregarTabela() {
      const { data } = await api_gateway.get(
        'api/v2/papers/read?contagem=true&pagina=' +
          paginaAtual +
          '&linhasPorPagina=' +
          valorLimite
      )
      // totalContador = data.contagem;

      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      function parseSeparadorLinha(separador) {
        if (separador === 'espaco') {
          return ' '
        } else if (separador === 'enter') {
          return '\n'
        } else {
          return separador
        }
      }

      function createArrayBusca(conteudoBusca) {
        let novoSeparador = parseSeparadorLinha(separadorLinhas)
        conteudoBusca = conteudoBusca.split(novoSeparador)

        return conteudoBusca
      }

      //CASO O FILTRO ESTEJA VAZIO E HAJA CONTEUDO DE BUSCA
      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          await contarItens()
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          let conteudoBarraBusca = []
          conteudoBarraBusca = createArrayBusca(conteudoBusca)
          const { data } = await api_gateway.get(
            '/api/v2/papers/read?contagem=true&pagina=' +
              paginaAtual +
              '&linhasPorPagina=' +
              valorLimite +
              '&busca=[' +
              conteudoBarraBusca +
              ']'
          )
          totalContador = data.item_count
          await contarItens()
          inserirData(data.papers)
        }
        //CASO NÃO HAJA CONTEÚDO DE BUSCA MAS O FILTRO NÃO ESTEJA VAZIO
      } else if (!filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVar = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post('/m1/filtrar/cliente', dados)
          inserirData(data.dados)
        }
        //APENAS EM CASOS ONDE O FILTRO ESTÁ VAZIO E NÃO HÁ CONTEÚDO NA BUSCA
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.get(
            'api/v2/papers/read?contagem=true&pagina=' +
              paginaAtual +
              '&linhasPorPagina=' +
              valorLimite
          )
          totalContador = data.item_count
          await contarItens()
          inserirData(data.papers)
        }
      }

      if (Object.keys(selectedRow).length) {
        if (selectedRow.selectedPage === paginaAtual) {
          selectedRow.selectedRow = await getEditedRow(selectedRow, data.papers)
          if (selectedRow.selectedRow) {
            despacho(desabilitarAcoes(false))
          } else {
            despacho(desabilitarAcoes(true))
          }
        } else if (selectedRow.selectedPage !== paginaAtual) {
          setSelectedRow({})
          despacho(desabilitarAcoes(true))
        }
      } else {
        despacho(desabilitarAcoes(true))
      }

      setSpinAtivo(false)
    }
    carregarTabela()
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData
    if (controladorPagina <= paginaAtual) {
      if (controladorPagina <= paginaAtual && filtros.vazio) {
        apiData = totalContador
      } else {
        apiData = totalContador
      }
      totalItens = apiData
      itensVar = []
      if (apiData) {
        totalPaginas = Math.ceil(apiData / valorLimite)
        for (var i = 0; i < apiData; i++) {
          arrayItens.push(i)
        }
        itensVar = arrayItens
      }
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  const colunas = [
    {
      dataField: 'CdPapel',
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      text: 'ID',
      sort: true,
      headerStyle: () => {
        return { width: '130px' }
      },
      formatter: (cell) => {
        return <p className="fonte-cor-20 label-tabela-nova-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'Codigo',
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      text: 'Código',
      sort: true,
      headerStyle: () => {
        return { width: '130px' }
      },
      formatter: (cell) => {
        return <p className="fonte-cor-20 label-tabela-nova-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'Nome',
      headerClasses: 'nao-selecionavel',
      text: 'Nome do Papel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-20 label-tabela-nova-1">{cell || '-'}</p>
      }
    },
    {
      dataField: 'Descricao',
      headerClasses: 'nao-selecionavel',
      text: 'Descrição',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-20 label-tabela-nova-1">{cell || '-'}</p>
      }
    }
  ]

  function setPropData(row) {
    if (row) {
      setNomePapel(row.Nome)
      setCodigoPapel(row.Codigo)
      setDescricaoPapel(row.Descricao)
      setIdPapel(row.CdPapel)
    }
  }

  const opcoesPaginacao = {
    page: paginaAtual,
    showTotal: true,
    sizePerPage: valorLimite,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Proxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (page) => {
      setPaginaAtual(page)
    }
  }

  async function handleDeletar() {
    setSpinAtivo(true)
    await api_gateway
      .get('/api/v2/papers/delete?id=' + idPapel)
      .then(function () {
        setRenderizar(!renderizar)
        handleMensagemSucesso(false)
        setSelectedRow({})
        setSpinAtivo(false)
      })
      .catch(function (error) {
        setMensagemErro(error.response.data.erro)
        despacho(revelarExcluirCliente(false))
        handleMensagemErro(false)
        setSpinAtivo(false)
      })
  }

  function handleMensagemAtencao(confirmacao) {
    if (confirmacao === true) {
      ColetaClickstream(1313) // dropAcoesRevelarExcluirClienteExcluir
      despacho(revelarExcluirCliente(false))
      handleDeletar()
    } else {
      ColetaClickstream(1024) // dropAcoesRevelarExcluirClienteCancelar
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemSucesso() {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
    }
  }

  return (
    <>
      <BarraDadosCliente />
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {NovoCliente === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroPapel
              tituloJanela="Cadastrar"
              setRevelarCadastro={setRevelarCadastro}
              setRevelarEdicao={setRevelarEdicao}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {EditarCliente === true && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <CadastroPapel
              tituloJanela="Editar"
              nomePapel={nomePapel}
              descricaoPapel={descricaoPapel}
              codigoPapel={codigoPapel}
              idPapel={idPapel}
              setRevelarCadastro={setRevelarCadastro}
              setRevelarEdicao={setRevelarEdicao}
              renderizar={renderizar}
              setRenderizar={setRenderizar}
            />
          </div>
        </div>
      )}
      {revelarBarraFiltro === true && <BarraFiltragem />}

      <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
        {({ paginationProps, paginationTableProps }) => (
          <>
            <BootstrapTable
              classes="tabela"
              condensed
              keyField="CdPapel"
              data={itens}
              columns={colunas}
              noDataIndication={!spinAtivo && 'Nenhum item encontrado'}
              {...paginationTableProps}
            />
            <PaginacaoTabela
              setPaginaAtual={setPaginaAtual}
              totalPaginas={totalPaginas}
              totalItens={totalItens}
              valorLimite={valorLimite}
              paginaAtual={paginaAtual}
              page={paginationProps.page}
              onPageChange={paginationProps.onPageChange}
            />
          </>
        )}
      </PaginationProvider>

      <div className="itens-exibidos-tabela fonte-cor-1">
        Mostrando
        <span className="label-tabela-itens-exibidos">{contador + 1}</span>-
        <span className="label-tabela-itens-exibidos">
          {contador + valorLimite <= totalItens
            ? contador + valorLimite
            : totalItens}
        </span>
        de
        <span className="label-tabela-itens-exibidos">{totalItens}</span>
      </div>

      {revelarMensagemSucesso && (
        <MensagemSucesso
          handleMensagemSucesso={handleMensagemSucesso}
          mensagemTitulo="Sucesso"
          mensagemParagrafo1={'O Papel ' + codigoPapel + ' foi deletado.'}
          mensagemBotao="Continuar"
        />
      )}
      {ExcluirCliente && (
        <MensagemConfirmarExclusao
          handleMensagemAtencao={handleMensagemAtencao}
          mensagemTitulo={'Deletar ' + dsNomeCliente}
        />
      )}
      {revelarMensagemErro && (
        <MensagemErro
          handleMensagemErro={handleMensagemErro}
          mensagemTitulo={mensagemErro}
          mensagemParagrafo1="Erro"
          mensagemParagrafo2={mensagemErro}
          mensagemBotao="Retornar"
        />
      )}
    </>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}

export default connect(mapStateToProps)(React.memo(Grid))
